import { render, staticRenderFns } from "./LegendTitle.vue?vue&type=template&id=57497137&scoped=true&"
import script from "./LegendTitle.vue?vue&type=script&lang=js&"
export * from "./LegendTitle.vue?vue&type=script&lang=js&"
import style0 from "./LegendTitle.vue?vue&type=style&index=0&id=57497137&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57497137",
  null
  
)

export default component.exports